
export const validatePhoneNumber = (phone) => {
    if (!phone) return false;
  
    const numeric = phone.replace(/\D/g, ''); // Remove all non-digit characters
  
    // Only validate if it starts with 1 (North American)
    if (numeric.startsWith('1')) {
      return numeric.length === 11;
    }
  
    // If it doesn't start with 1, skip validation by returning true
    return true;
  };
   
export const validateEmail = (email) => {
  // Basic email validation
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validatePassword = (password) => {
  const errors = [];

  if (password.length < 8) {
    errors.push("Password must be at least 8 characters.");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("Must include at least one uppercase letter.");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("Must include at least one lowercase letter.");
  }
  if (!/[0-9]/.test(password)) {
    errors.push("Must include at least one number.");
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push("Must include at least one special character.");
  }

  return errors;
};

// ✅ Credit card number (16 digits only, optional spaces allowed)
export const validateCardNumber = (number) => {
  const cleanNumber = number.replace(/\s+/g, "");
  return /^\d{16}$/.test(cleanNumber);
};

// ✅ Expiry date (MM/YY or MM/YYYY)
// export const validateExpiryDate = (date) => {
//   // Accept MM/YY or MM/YYYY
//   const shortFormat = /^(0[1-9]|1[0-2])\/\d{2}$/;
//   const longFormat = /^(0[1-9]|1[0-2])\/\d{4}$/;
//   return shortFormat.test(date) || longFormat.test(date);
// };
export const validateExpiryDate = (date) => {
  // Accept MM/YY or MM/YYYY
  const shortFormat = /^(0[1-9]|1[0-2])\/\d{2}$/;
  const longFormat = /^(0[1-9]|1[0-2])\/\d{4}$/;

  let month, year;

  if (shortFormat.test(date)) {
    [month, year] = date.split("/").map(Number);
    year += 2000; // Convert YY to YYYY
  } else if (longFormat.test(date)) {
    [month, year] = date.split("/").map(Number);
  } else {
    return false; // Invalid format
  }

  // Get the current month and year
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // JS months are 0-based
  const currentYear = now.getFullYear();

  // Expiry must be later than the current month of the current year
  if (year < currentYear) return false;
  if (year === currentYear && month < currentMonth) return false;

  return true;
};


// ✅ CVV/Security code (3 or 4 digits)
export const validateSecurityCode = (code) => {
  return /^\d{3,4}$/.test(code);
};

// ✅ ZIP/Postal code (Canadian postal code format: A1A 1A1 or A1A1A1)
export const validateZipCode = (zip) => {
  return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip);
};

// ✅ Card Brand (optional but if needed, restrict to known brands)
export const validateCardBrand = (brand) => {
  const allowedBrands = ["visa", "mastercard", "amex"];
  return allowedBrands.includes(brand);
};

  